import controller from './live-motion-card.controller';

const template = require('./live-motion-card.html');

export default {
    bindings: {
        card: '<',
        canUpdate: '<',
    },
    template,
    controller
};